import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Gocdtemplate extends Component {
 
  render() {
    const course =[
      {
        title:"Introduction and Installation of GOCD",
         content:["Introduction Of GoCD","Concepts in GoCD","Value Stream Map","Installing GoCD","Installing GoCD Agent",]
      },
      {
        title:"Configuring GoCD",
        content:["	Managing Pipelines and Dependencies","Managing Agents","Managing Environments","Managing Users","Secrets Management","Artifacts","Email server configuration"]
      },
      {
        title:"Advanced Usage",
        content:["Pipelines as code","Auto Register a Remote Agent","Spawn multiple instances of a Job","Multiple Agents on One Machine","Conditional Task Execution","Compare Builds","Graphs","Backup GoCD Server","Agent Health Check API","GoCD Business Continuity","Integrating GoCD with other tools"]
      },
      {
        title:"GoCD on Kubernetes",
        content:["Introduction","Setup and configuration","Install the GoCD Helm chart","Importing a sample workflow","An explanation of the sample pipelines","Docker workflows"]
      },
      {
        title:"Plugins in GoCD",
        content:["Available extension points","Plugin User Guide","Package Repository Extension","Yum Repository Poller","SCM Extension","Task Extension"]
      },
      {
        title: "GoCD Security",
        content: [
        "GoCD security model",
        "GoCD authentication and authorization",
        "GoCD security configuration",
        "GoCD security best practices",
        "GoCD security auditing"
        ]
        },
    ]
   
    const faqData = [
      {
        question: 'What is GoCD Training?',
        answer:
          'GoCD Training is a specialized program designed to equip individuals with the skills and knowledge required to effectively implement continuous delivery pipelines using GoCD, an open-source continuous integration and continuous delivery (CI/CD) tool',
      },
      {
        question: 'Why is GoCD Training important?',
        answer:
          'GoCD Training is crucial for professionals seeking to automate and streamline software delivery processes, enabling faster and more reliable releases of software applications',
      },
      {
        question: 'Who can benefit from GoCD Training?',
        answer:
          'GoCD Training at the best training centre is suitable for software developers, DevOps engineers, system administrators, and anyone involved in software delivery and deployment'
        
        },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'GoCD skills can pursue a variety of career opportunities such as DevOps Engineer, Continuous Delivery Engineer, Build and Release Engineer, and Site Reliability Engineer (SRE).'
        
        },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a transformative journey into GoCD at the Best Training Centre. Our comprehensive GoCD training program welcomes learners from diverse backgrounds, regardless of prior experience in continuous delivery and DevOps practices. Whether you're a software developer, DevOps engineer, or IT professional looking to streamline your software delivery pipelines, our courses cater to individuals at every skill level. With a focus on practical application and hands-on learning, our expert instructors guide you through essential GoCD concepts, including pipeline configuration, version control integration, automated testing, and deployment strategies. At the Best Training Centre, we prioritize accessibility and inclusivity, ensuring that all learners have the opportunity to excel in harnessing the power of GoCD. Join us and discover your potential with the best training centre"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
     return(
      <>
        
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="GoCD is an open-source tool which is used in software development to help teams and organizations automate the continuous delivery (CD) of software. It supports automating the entire build-test-release process from code check-in to deployment."/> */}
           
          <NewMainsec rating='4.3' students={"368"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="GoCD is an open-source tool which is used in software development to help teams and organizations automate the continuous delivery (CD) of software. It supports automating the entire build-test-release process from code check-in to deployment."/>

            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		        <Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`GoCD ${this.props.location1} is a highly sought-after field with an increasing demand for professionals with GoCD skills. At Learnsoft.org, we provide top-notch GoCD training courses in ${this.props.location} to help individuals improve their skills and gain a comprehensive understanding of GoCD principles and practices. Our experienced trainers employ a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. Whether you're new to GoCD or looking to expand your skill set, Learnsoft.org's GoCD ${this.props.location1} is the perfect choice to advance your career. Contact us today to learn more about our courses and embark on your GoCD journey.`} 
            title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our GoCD course covers a wide range of topics, including continuous delivery pipeline, pipeline as code, and cloud infrastructure. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you comprehend the concepts and techniques used in GoCD. By the end of the course, you will be able to implement GoCD practices in your own projects."}/>
		      </section>
 <Batchtime title={this.props.title} fees="25,999" offer="18,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>   
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou1="AWS DevOps" coupath1="aws-devops" cou='Azure DevOps' coupath='azure-devops' cou9='Azure Administration' coupath9='azure-admin' cou3='Azure' coupath3='azure' cou10='Azure Developer' coupath10='azure-developer'
          cou5='Kubernetes' coupath5='kubernetes' cou6='Jenkins' coupath6='jenkins' cou7='DevSecOps' coupath7='devsecops'
          cou8='Terraform' coupath8='terraform' cou2='DevOps' coupath2='devops'  cou4='Docker' coupath4='docker' />

      </>
    );
  }
}
